import { GetAppLink } from "./GetAppLink";
import { useT } from "../../i18n/LangContext";

export const MobileBar = () => {
  const t = useT();
  return (
    <div className="fixed inset-x-0 bottom-0 z-50 border-t border-black/10 bg-white px-4 pb-[calc(12px+env(safe-area-inset-bottom))] pt-3 sm:hidden" data-testid="mobile-get-app-bar">
      <GetAppLink
        fallback={`${t.slug ? t.home : ""}#download`}
        className="flex h-12 w-full items-center justify-center rounded-lg bg-black text-base font-medium text-white active:bg-zinc-800"
        testid="mobile-get-app-btn"
      >
        {t.getApp}
      </GetAppLink>
    </div>
  );
};
